module.exports = __webpack_public_path__ + "4703b1fe75abbe77725abb364f6c1cce.webp";